const SERVICE_AREAS = {
  FILTERING: "FILTERING",
  CREATING: "CREATING",
  DELETING: "DELETING",
  UPDATING: "UPDATING",
  SEARCHING: "SEARCHING",
  FILTER_SERVICE_AREAS: "FILTER_SERVICE_AREAS",
  CREATE_SERVICE_AREA: "CREATE_SERVICE_AREA",
  EDIT_SERVICE_AREA: "EDIT_SERVICE_AREA",
  SEARCH_SERVICE_AREAS: "SEARCH_SERVICE_AREAS",
};

export default SERVICE_AREAS;
